<template>
  <Modal :open="displayModal" title="Add User" size="large" modalIcon="fad fa-user-plus"
    modalIconColor="bg-blue-100 text-blue-700" :showEscapeButton="true" :showAcceptButton="true"
    :acceptButtonProgress="isProgressing" acceptButtonText="Add User" @close="displayModal = false" @onSuccess="addUser"
    ref="modal">
    <div class="grid grid-cols-1 gap-4">
      <div>
        <label for="user_name" class="block text-sm font-medium text-gray-700">Name</label>
        <input type="text" name="user_name" id="user_name"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="data.name" />
      </div>
      <div>
        <label for="user_email" class="block text-sm font-medium text-gray-700">Email</label>
        <input type="email" name="user_email" id="user_email"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="data.email" />
      </div>

      <div>
        <label for="user_permission" class="block text-sm font-medium text-gray-700 mb-1">Select Role</label>
        <select id="user_permission" name="user_permission"
          class="block w-full focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md" v-model="data.role">
          <option value="videographer">Videographer</option>
          <option value="media_purchaser">Media Purchaser</option>
          <option value="media_producer">Media Producer</option>
          <option value="administrator">Administrator</option>
          <option value="superadministrator">Super Administrator</option>
        </select>
      </div>

      <div v-if="data.role == 'media_purchaser' || data.role == 'media_producer'">
        <label for="user_network" class="block text-sm font-medium text-gray-700">Network</label>
        <label class="dropdown_wrap">
          <select class="block w-full focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md"
            v-model="data.network">
            <option v-for="network in networks" :value="network.id" v-bind:key="network.id">{{ network.name }}</option>
          </select>
        </label>
      </div>
      <div v-if="data.role !== 'media_purchaser' && data.role !== 'media_producer'">
        <label for="user_percentage" class="block text-sm font-medium text-gray-700">Percentage</label>
        <input type="number" name="user_percentage" id="user_percentage"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="data.percentage" />
      </div>
      <div v-if="data.role !== 'media_purchaser' && data.role !== 'media_producer'">
        <label for="user_percentage" class="block text-sm font-medium text-gray-700">Social Percentage</label>
        <input type="number" name="user_percentage" id="user_percentage"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="data.social_percent" />
      </div>
      <div>
        <label for="userPassword" class="block text-sm font-medium text-gray-700">Password</label>
        <div class="flex flex-row">
          <div class="relative flex items-stretch flex-grow">
            <input
              class="focus:ring-blue-500 focus:border-blue-500 block w-full rounded-none rounded-l-md sm:text-sm border-gray-300"
              id="userPassword" type="text" v-model="data.password" />
          </div>
          <button
            class="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
            v-on:click="makePassword">
            <i class="fa fa-sync"></i>
          </button>
        </div>
      </div>

      <div class="flex flex-row space-x-4 items-center pl-4">
        <input name="" id="viralDrmClient" type="checkbox"
          class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded focus:outline-none"
          v-model="data.viral_drm_client" />
        <label for="viralDrmClient" class="sm:text-sm">
          ViralDRM Client
        </label>
      </div>

    </div>
  </Modal>
</template>

<script>
import * as Config from "@/config";
import { mapActions } from "vuex";

import Modal from "@/components/Modal";

export default {
  data() {
    return {
      displayModal: false,
      data: {
        name: null,
        email: null,
        role: "videographer",
        network: null,
        percentage: null,
        password: null,
        social_percent: null,
        viral_drm_client: false,
      },
      isProgressing: false,
      networks: []
    };
  },

  components: {
    Modal
  },

  mounted() {
    this.$nextTick(
      function () {
        this.$eventBus.$on("admin-add-user-open-modal", this.open);
      }.bind(this)
    );
  },

  destroyed() {
    this.$eventBus.$off("admin-add-user-open-modal", this.open);
  },

  methods: {
    ...mapActions(["addToastMessage"]),
    open(data) {
      this.displayModal = true;
      this.getNetworks();
    },

    async addUser() {
      let response = await this.$http.post(
        Config.apiPath + "/api/v2/admin/users/new",
        this.data
      );
      if (response.status == 200) {
        this.$eventBus.$emit("admin-add-user-refresh-data");
        this.addToastMessage({
          title: "Success",
          text: this.data.name + " was successfully added.",
          type: "success"
        });
        this.displayModal = false;
      } else {
        this.addToastMessage({
          title: "Whoops!",
          text:
            "An error was encountered while trying to add an account for " +
            this.data.name +
            ".",
          type: "error"
        });
      }
    },

    makePassword() {
      var text = "";
      var possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (var i = 0; i < 20; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      this.data.password = text;
    },

    async getNetworks() {
      let response = await this.$http.get(
        Config.apiPath + "/api/v2/admin/networks"
      );
      this.networks = response.data;
    }
  }
};
</script>
